import Axios from "./axios_helper"
import Config from '../config'
import CryptoJS from 'crypto-js';

export const baseUrl = () => {
  const baseUrl = process.env.REACT_APP_ENV=="production" ? Config.applicationSettings.productionBaseURL : Config.applicationSettings.developmentBaseURL;
  return baseUrl;
}

export const jsonToFormData = (json,formData=new FormData()) => {
    for (const key in json) {
      if (json.hasOwnProperty(key)) {
        formData.append(key, json[key]);
      }
    }
    return formData;
}

export const downloadFile = (url, fileName) => {
  let link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.target = '_blank';

  // Check if the file is an image
  if (url.endsWith('.jpg') || url.endsWith('.jpeg') || url.endsWith('.png') || url.endsWith('.gif')) {
    // If it's an image, open it in a new window
    window.open(url, '_blank');
  } else {
    // If it's not an image, download it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

export const getTextFromUrl = (url) => {
  return fetch(url)
    .then(response => response.text());
}

export const downloadImage=(imageSrc)=> {
  if(!imageSrc)return false;
  const blob = dataURItoBlob(imageSrc);
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  var nameArray = this.expense.expense.documentpath.split('/');
  link.download = nameArray[nameArray.length-1];
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export const downloadFileFromLink = (fileLink) => {
  if (!fileLink) return false;

  const fileName = fileLink.split('/').pop() || 'downloaded_file';

  const link = document.createElement('a');
  link.href = fileLink;

  link.download = fileName;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  return true;
};

export const downloadFileInNewPage = (fileLink) => {
  if (!fileLink) return false;

  // Open a new tab
  const newTab = window.open();

  if (!newTab) {
    console.error("Failed to open a new tab.");
    return false;
  }

  // Write HTML in the new tab to trigger the download
  newTab.document.write(`
    <html>
      <body>
        <script>
          window.location.href = '${fileLink}';
          setTimeout(() => {
            window.close();
          }, 1000); // Wait 1 second before closing
        </script>
      </body>
    </html>
  `);

  return true;
};


const dataURItoBlob=(dataURI)=> {
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
}

export const convertToWebP = (selectedFile,setImageSrc) => {
  const canvas = document.createElement("canvas");
  const img = document.createElement("img");
  img.src = URL.createObjectURL(selectedFile);
  img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext("2d").drawImage(img, 0, 0);
      const webpDataUrl = canvas.toDataURL("image/webp");
      if(setImageSrc)setImageSrc(webpDataUrl);
  };
};

export const separateCamelCaseString = (camelCaseString ,sum=0) => {
  camelCaseString = camelCaseString.replace(/([a-z])([A-Z])/g, '$1 $2');
  camelCaseString = camelCaseString.replace(/\[(\d+)\]/g, (_, num) => ` ${parseInt(num, 10) + sum}`);
  camelCaseString = camelCaseString.charAt(0).toUpperCase() + camelCaseString.slice(1);
  return camelCaseString;
};

export const getsimplifyLink = (link) =>{
  link = link.replace(/\\/g, '/');
  link = link.replace(':/','://');
  return link;
}

export const getBase64FromImageLink = async (link) =>{
  link = getsimplifyLink(link);
  return Axios.get(link, { responseType: 'arraybuffer' })
  .then(response => {
    const base64Image = btoa(
      new Uint8Array(response.data)
        .reduce((data, byte) => data + String.fromCharCode(byte), '')
    );
    return 'data:image/png;base64,'+base64Image;
  })
  .catch(error => {
    console.log(error);
  });
}

export const getInLocalDatTime = async (dateTime) =>{
  const options = { timeZone: 'Asia/Dhaka', dateStyle: 'medium', timeStyle: 'short' };
  return new Date(dateTime).toLocaleString('en-BD', options);
}

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(Config.applicationSettings.secretKey),{ iv: { words: [ 0, 0, 0, 0 ], sigBytes: 16 } }).toString();
};

export const decryptData = (encryptedData) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, CryptoJS.enc.Utf8.parse(Config.applicationSettings.secretKey),{ iv: { words: [ 0, 0, 0, 0 ], sigBytes: 16 } });
  return bytes.toString(CryptoJS.enc.Utf8);
};